import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [자동화>자동화 수행 결과] 자동화 수행결과의 트리거 별 결과 목록 리스트를 조회
   * @author najongdang
   * @param  {Object} params
   * @return {Map}
   */
  getTriggerExecutionResultList(params) {
    return axios.post(`${baseUrl}/ams/result/get-trigger-execution-result-list.do`, params);
  },
  /**
   * [자동화>자동화 수행 결과] 자동화 수행결과의 트리거별 결과 목록의 resultStatus별 갯수를 시간별로 조회
   * @author najongdang
   * @param  {Object} params
   * @return {Map}
   */
  getTriggerExectionResultStackedColumnChartData(params) {
    return axios.post(`${baseUrl}/ams/result/get-trigger-execution-result-stacked-column-chart.do`, params);
  },
  /**
   * [자동화>자동화 수행 결과] 자동화 수행결과의 트리거 별 갯수 목록을 조회
   * @author najongdang
   * @param  {Object} params
   * @return {Map}
   */
  getResultCountListByTrigger(params) {
    return axios.post(`${baseUrl}/ams/result/get-result-count-list-by-trigger.do`, params);
  },
  /**
   * [자동화>자동화 수행 결과] 자동화 수행결과의 결과 상태 별 갯수 목록을 조회
   * @author najongdang
   * @param  {Object} params
   * @return {Map}
   */
  getResultCountListByResultStatus(params) {
    return axios.post(`${baseUrl}/ams/result/get-result-count-list-by-result-status.do`, params);
  },
  /**
   * [자동화>자동화 수행 결과] 자동화 수행결과의 결과 trigger_exec_id 별 상세 결과 목록을 조회
   * @author najongdang
   * @param  {Object} params
   * @return {Map}
   */
  getTriggerExecutionResultDetailList(params) {
    return axios.post(`${baseUrl}/ams/result/get-trigger-execution-result-detail-list.do`, params);
  },
  /**
   * [자동화>자동화 수행 결과] 자동화 수행결과에서 선택된 result buffer를 조회
   * @author najongdang
   * @param  {Object} params
   * @return {Map}
   */
  getResultBuffer(params) {
    return axios.post(`${baseUrl}/ams/result/get-result-buffer.do`, params);
  },
  /**
   * [자동화>자동화 수행 결과] 자동화 수행결과의 RawData를 조회
   * @author najongdang
   * @param  {Object} params
   * @return {Map}
   */
  getTriggerExecutionResultRawDataList(params) {
    return axios.post(`${baseUrl}/ams/result/get-trigger-execution-result-raw-data-list.do`, params);
  },
  /**
   * [자동화>자동화 수행 결과] 자동화 수행결과의 수행결과 별 RawData 갯수를 조회
   * @author najongdang
   * @param  {Object} params
   * @return {Map}
   */
  getRawDataResultCountListByResultStatus(params) {
    return axios.post(`${baseUrl}/ams/result/get-raw-data-result-count-list-by-result-status.do`, params);
  },
  /**
   * [자동화>자동화 수행 결과] 자동화 수행결과의 trigger_id 별 RawData 갯수를 조회
   * @author najongdang
   * @param  {Object} params
   * @return {Map}
   */
  getRawDataResultCountListByTrigger(params) {
    return axios.post(`${baseUrl}/ams/result/get-raw-data-result-count-list-by-trigger.do`, params);
  },
  /**
   * [자동화>자동화 수행 결과] 자동화 수행결과의 rawData 목록의 resultStatus별 갯수를 시간별로 조회
   * @author najongdang
   * @param  {Object} params
   * @return {Map}
   */
  getTriggerExectionResultRawDataStackedColumnChartData(params) {
    return axios.post(`${baseUrl}/ams/result/get-trigger-execution-result-raw-data-stacked-column-chart.do`, params);
  },
  /**
   * [자동화>자동화 수행 결과] 자동화 수행결과의 트리거 별 결과 목록 엑셀 파일 출력
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  exportTriggerExecRsltListExcel(params) {
    return axios.post(`${baseUrl}/ams/result/export-trigger-exec-rslt-list-excel.do`, params);
  },
  /**
   * [자동화>자동화 수행 결과] 자동화 수행결과의 rawData 목록 엑셀 파일 출력
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  exportTriggerExecRsltRawDataListExcel(params) {
    return axios.post(`${baseUrl}/ams/result/export-trigger-exec-rslt-raw-data-list-excel.do`, params);
  },
  getTrgExecResultBufferChangeHist(params) {
    return axios.post(`${baseUrl}/ams/result/get-trg-exec-result-buffer-change-hist.do`, params);
  },
  getTrgExecResultBufferComparedData(params) {
    return axios.post(`${baseUrl}/ams/result/get-trg-exec-result-buffer-compared-data.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/ams/result.js